/* eslint-disable no-console */
import { log, supabase } from ".";

/**
 * Obtiene todos los movimientos de crédito de un cliente, ordenados por fecha descendente.
 */
export const getCreditosCliente = async (clientId) => {
  try {
    const data = await supabase.select("cliente_creditos", {
      filters: { client_id: String(clientId) },
      orderBy: "created_at",
      ascending: false,
    });
    return data || [];
  } catch (error) {
    log.error("getCreditosCliente", error);
    throw error;
  }
};

/**
 * Calcula el saldo disponible de crédito por moneda para un cliente.
 * Retorna un objeto: { CLP: 500000, USD: 1000, ... }
 */
export const getSaldoCredito = async (clientId) => {
  try {
    const movimientos = await getCreditosCliente(clientId);
    if (movimientos.length === 0) return {};

    const saldos = {};
    for (const mov of movimientos) {
      if (!saldos[mov.moneda]) saldos[mov.moneda] = 0;
      if (mov.tipo === "carga") {
        saldos[mov.moneda] += Number(mov.monto);
      } else if (mov.tipo === "consumo") {
        saldos[mov.moneda] -= Number(mov.monto);
      }
    }

    // Filtrar monedas con saldo 0
    const result = {};
    for (const [moneda, saldo] of Object.entries(saldos)) {
      if (saldo !== 0) result[moneda] = saldo;
    }
    return result;
  } catch (error) {
    log.error("getSaldoCredito", error);
    throw error;
  }
};

/**
 * Registra un movimiento de crédito (carga o consumo).
 * Calcula automáticamente el saldo_despues.
 */
export const registrarCredito = async ({
  clientId,
  pais,
  tipo,
  monto,
  moneda,
  referenciaId,
  referenciaTipo,
  descripcion,
  usuarioId,
}) => {
  try {
    // Obtener saldo actual de esa moneda
    const saldos = await getSaldoCredito(clientId);
    const saldoActual = saldos[moneda] || 0;
    const saldoDespues = tipo === "carga" ? saldoActual + monto : saldoActual - monto;

    const data = await supabase.insert("cliente_creditos", {
      client_id: clientId,
      pais,
      tipo,
      monto,
      moneda,
      saldo_despues: saldoDespues,
      referencia_id: referenciaId || null,
      referencia_tipo: referenciaTipo || null,
      descripcion: descripcion || null,
      usuario_id: usuarioId,
    });

    if (!data || data.length === 0) throw new Error("Empty response");

    return data;
  } catch (error) {
    console.error("registrarCredito error:", error);
    log.error("registrarCredito", error);
    throw error;
  }
};
